import * as React from "react";
import { ImageField, ReferenceField, TextField } from "react-admin";
import { Card, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Draggable } from "@hello-pangea/dnd";
import { getRewardStatusName } from "../utils/RewardUtils";
import { getDaysAgo } from "../utils/DateTimeUtils";

const ProductImageField = ({ reward }) => {
  const productIndex = reward?.restaurant?.rewards?.findIndex(
    (rr) => rr._id === reward?.restaurantReward
  );

  if (productIndex === undefined) return null;

  return (
    <ReferenceField
      source={`restaurant.rewards[${productIndex}].product`}
      record={reward}
      reference="products"
    >
      <ImageField
        source="images[0].url"
        label="Imagen"
        sx={{
          "& img": {
            maxWidth: 70,
            maxHeight: 70,
            objectFit: "contain",
          },
        }}
      />
    </ReferenceField>
  );
};

const ProductNameField = ({ reward }) => {
  const productIndex = reward?.restaurant?.rewards?.findIndex(
    (rr) => rr._id === reward?.restaurantReward
  );

  if (productIndex === undefined) return null;

  return (
    <ReferenceField
      label="Producto"
      reference="products"
      record={reward}
      source={`restaurant.rewards[${productIndex}].product`}
      link={false}
    >
      <TextField
        source="name"
        label="Nombre"
        variant="subtitle1"
        sx={{ color: "textPrimary" }}
      />
    </ReferenceField>
  );
};

const RewardCard = ({ reward, index }) => {
  const theme = useTheme();
  if (!reward) return null;

  return (
    <Draggable draggableId={String(reward?.id)} index={index}>
      {(provided, snapshot) => (
        <div
          style={{ marginBottom: theme.spacing(1) }}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          <Card
            style={{
              opacity: snapshot.isDragging ? 0.9 : 1,
              transform: snapshot.isDragging ? "rotate(2deg)" : "",
            }}
            elevation={snapshot.isDragging ? 4 : 2}
          >
            <div style={{ padding: theme.spacing(1), display: "flex", flexDirection: "row", alignItems: "center" }}>
              <ProductImageField reward={reward} />
              <div style={{ display: "flex", flex: 1, flexDirection: "column", alignItems: "flex-start", paddingLeft: theme.spacing(1) }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                  <Typography variant="body2" color="textSecondary">
                    {getDaysAgo(reward?.updatedAt)}
                  </Typography>
                </div>
                <ProductNameField reward={reward} />
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", paddingRight: theme.spacing(1) }}>
                  <Typography variant="subtitle2" color="primary" sx={{ mt: 1 }}>
                    {getRewardStatusName(reward?.status)}
                  </Typography>
                  {!reward?.deliveryCode && (
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                      No requiere código
                    </Typography>
                  )}
                </div>
              </div>
            </div>
          </Card>
        </div>
      )}
    </Draggable>
  );
};

export default RewardCard;
